var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm.formatDate(_vm.value)))]):_c('span',[_vm._t("default",function(){return [_c('span',{staticClass:"date empty"},[_vm._v("NULL")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }